import Vue from 'vue'
import Croppa from 'vue-croppa'

import 'vue-croppa/dist/vue-croppa.css'

Vue.use(Croppa)
